export const environment = {
  production: false,
  clientId: '',
  tenantId: '',
  authority: '',
  apiUrl: '',
  apiUrl_RBAC: '',
  apiUrl_GIS: '', 
  apiUrl_CommonGIS: '', 
  Ocp_Apim_Subscription_Key: '', 
  osMap_Key: 'GAa6gap7q2f0clsYjxFIVu4k70wYZ1aA', 
  MYIM_CACHE_URL: '',
  apiTimeOut:'',
  appInsights:'',
  mapServerConfig: {
    baseUrl: "", 
    wmsUrl: '/wms',
    wfsUrl: '/wfs',
    getFeatureParams: [
      'SERVICE=WFS',
      'VERSION=1.0.0',
      'REQUEST=GetFeature',
      'OUTPUTFORMAT=application/json'
    ],
    featureInfoParams: [
      'SERVICE=WMS',
      'VERSION=1.3.0',
      'REQUEST=GetFeatureInfo',
      'FORMAT=image/png',
      'TRANSPARENT=true',
      'INFO_FORMAT=application/json',
      'STYLES=',
      'EXCEPTIONS=application/json',
      'FEATURE_COUNT=10',
      'BUFFER=5'
    ]
  }
};
